import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
 // ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'print';
export const selectPrintState = state => state[STORE_KEY];
export const selectPrint = state => selectPrintState(state).currentPrint;
 // ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentPrint: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
  rookiesOnly: false,
  title: '',
};
export const printReducer = (state = initialState, action) => {
  const handler = actions[action.type];
   return handler ? handler(state, action) : state;
};
export default printReducer;
 // ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_PRINT_REQUEST = `${STORE_KEY}/LOAD_PRINT_REQUEST`;
export const LOAD_PRINT_SUCCESS = `${STORE_KEY}/LOAD_PRINT_SUCCESS`;
export const LOAD_PRINT_ERROR = `${STORE_KEY}/LOAD_PRINT_ERROR`;

export const loadPrintRequest = payload => ({
  type: LOAD_PRINT_REQUEST,
  payload: { ...payload },
});
export const loadPrintSuccess = ({ cheatsheet }, year, week, formulaId, title, rookiesOnly) => ({
  type: LOAD_PRINT_SUCCESS,
  payload: { cheatsheet, year, week, formulaId, title, rookiesOnly },
});
export const loadPrintError = error => ({
  type: LOAD_PRINT_ERROR,
  payload: { error },
});


 actions[LOAD_PRINT_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
  rookiesOnly: payload.rookiesOnly,
});
actions[LOAD_PRINT_SUCCESS] = (state, { payload }) => {
    return ({ ...state,
  hasLoaded: true,
  currentPrint: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
  rookiesOnly: payload.rookiesOnly,
  title: payload.title
})};
actions[LOAD_PRINT_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});


export const loadPrint = (year, week, formulaId, title, rookiesOnly) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadPrintRequest(year, week, formulaId, rookiesOnly));
    let print = null;

    switch (title) {
        case 'cheatsheets': print = await api.cheatSheets.getByWeek(year, week, formulaId, rookiesOnly); break;
        case 'dynasty': print = await api.cheatSheets.getByWeekDynasty(year); break;
        case 'auction-10-team': print = await api.cheatSheets.getByWeekAuction10(year); break;
        case 'auction-12-team': print = await api.cheatSheets.getByWeekAuction12(year); break;
        case 'top-200-standard': print = await api.cheatSheets.getByWeekTop200(year); break;
        case 'top-200-ppr': print = await api.cheatSheets.getByWeekTop200PPR(year); break;
        case 'top-200-qb-heavy': print = await api.cheatSheets.getByWeekTop200QB(year); break;
    }
    return dispatch(loadPrintSuccess(print, year, week, formulaId, title, rookiesOnly));
  } catch (error) {
    console.error(error);
    return dispatch(loadPrintError(error));
  } finally {
    dispatch(endTask());
  }
};

 // ------------------------------------
// View
// ------------------------------------
export const PRINT_VIEW = `${STORE_KEY}/PRINT_VIEW`;
 viewNames[PRINT_VIEW] = 'Print';
routes[PRINT_VIEW] = {
  path: '/:title/:year/:week/:formulaId/:rookiesOnly/print',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year, title, week, formulaId, rookiesOnly } = state.location.payload;
    await dispatch(loadPrint(year, week, formulaId, title, rookiesOnly));
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Print/module/print.js